/* eslint-disable react/prop-types */
import { React } from "react";

import { Message } from "semantic-ui-react";

// eslint-disable-next-line arrow-body-style
const DisplayCognitoError = ({ errorMessage }) => {
  let displayError =
    "Nous sommes désolés, une erreur s'est produite. Veuillez vous référer l'administrateur de COMTEL Technologies.";

    

  if (errorMessage && errorMessage.code === "UsernameExistsException") {
      displayError = "Votre adresse e-mail existe déjà dans nos systèmes";
  }
  if (errorMessage && errorMessage.code === "UserNotFoundException") {
    displayError = "Votre adresse e-mail n'existe pas";
  }
  if (errorMessage && errorMessage.code === "UserNotConfirmedException") {
    displayError =
      "Votre adresse e-mail n'a pas été validée par l'administrateur de COMTEL Technologies.";
  }
  if (errorMessage && errorMessage.code === "CodeMismatchException") {
    displayError = "Le code de validation n'est pas valide.";
  }
  if (errorMessage && errorMessage.code === "LimitExceededException") {
    displayError = "Limite de tentatives dépassée, veuillez réessayer après un certain temps";
  }
  if (errorMessage && errorMessage.code === "NotAuthorizedException") {
    displayError = "Identifiant ou mot de passe incorrect.";
  }
  if (errorMessage && errorMessage.code === "InvalidParameterException") {
    displayError = "Impossible de réinitialiser le mot de passe de l'utilisateur car il n'y a pas d'e-mail ou de numéro de téléphone enregistré/vérifié.";
  }
  if (errorMessage && errorMessage.code === "InvalidPasswordException") {
    displayError = "Le mot de passe n'est pas conforme à la stratégie : le mot de passe n'est pas assez long.";
  }
  

  
  

  return (
    <>
      {errorMessage && (
        <Message negative>
          <p>{displayError}</p>
        </Message>
      )}
    </>
  );
};
export default DisplayCognitoError;
